import { GepoUser } from "../../features/tender_page/tender.module";

export const enum CommentType {
	SYSTEM = "SYSTEM",
	USER = "USER"
}

export interface Comment {
	id: number;
	object_id: number;
	file_id: number;
	file: string;
	creator_id: number;
	creator: GepoUser;
	type: CommentType;
	comment: string;
	created_at: string;
}

export enum CommentObjectClass {
    TENDER="tender",
    CONTRACTPERIOD = "contractperiod"
}
export  interface CreateComment {
    object_id: number
    object_class: CommentObjectClass
    comment: string
}

export interface ListComment {
	data:Comment[]
    page: number,
    page_size: number,
    has_more: boolean
}